export default __webpack_public_path__ + "assets/e8718f1a8d07de5dda230062b7203f4a.png";